<template>
  <div v-if="terms" class="terms notranslate" :class="{open: detail}">
    <button type="button" class="btn btnRound btnWhite btnFull btnViewDetail" @click="viewDetail">{{locale.terms_refund}}<i></i></button>
    <div v-if="detail" class="termsBox">
      {{termsMessage}}
    </div>
    <div class="checkbox mt10">
      <input type="checkbox" id="agree_order_refund" v-model="agree">
      <label for="agree_order_refund">{{locale.agree_terms_refund}}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RefundTerms',
  props: [
    'lang',
    'locale',
    'pgInfo'
  ],
  computed: {
    termsMessage () {
      const lang = this.lang
      return this.terms ? this.terms[lang] : '-'
    },
    agree: {
      get () {
        return this.$store.getters['payment/getAgree'].refund
      },
      set (isAgree) {
        const data = {
          terms: 'refund',
          isAgree: isAgree
        }
        this.$store.commit('payment/setAgree', data)
      }
    }
  },
  mounted () {
    const pgInfo = this.pgInfo
    this.$store.commit('payment/setAgree', { terms: 'refund', isAgree: false })
    this.$store.dispatch('payment/getRefundTerms', pgInfo).then((res) => {
      this.terms = res
    })
  },
  data () {
    return {
      terms: null,
      detail: false
    }
  },
  methods: {
    viewDetail () {
      this.detail = !this.detail
    }
  }
}
</script>

<style lang="scss" scoped>
.terms {
  margin-top: 15px;
}
.btn {
  position: relative;
  text-align: left;
  i {
    position: absolute;
    top: 50%;
    right: 15px;
    width: 10px;
    height: 10px;
    margin-top: -7px;
    border-bottom: 2px solid $color-lgrey2;
    border-right: 2px solid $color-lgrey2;
    transform: rotate(45deg);
  }
}
.btnViewDetail {
  padding-right: 32px !important;
}
.termsBox {
  height: 100px;
  padding: 0.5em;
  overflow: auto;
  font-size: 12px;
  color: $color-grey;
  border: 1px solid $color-lgrey2;
  border-top: none;
  background-color: $bg-default;
}
.open {
  .btn i {
    margin-top: -2px;
    transform: rotate(225deg);
  }
}
.checkbox {
  label {
    color: $color-grey;
  }
  :checked + label {
    color: inherit;
  }
}
</style>
